import React, { useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import SelectManager from './SelectManager';
import SelectConsultants from './SelectConsultants';
import { SHOW_COMPANY_CLAIM_GROUP_EDIT_FORM_FIELDS, SPRINT_CLAIM_NAME, TASK_TITLE, CLAIM_GROUP_EDIT_PAGE_SHOW_YEAR_END_DROPDOWN, SHOW_QUESTIONNAIRES_SELECT_SEPARATELY } from '@rd-web-markets/market/dist/constants';
import { useTranslation } from 'react-i18next';
import ImmutableUnderReviewCompanyFormControl from '../util/reviewEditControls/ImmutableUnderReviewCompanyFormControl';
import ClaimTemplateTasksSelection from './ClaimTemplateTasksSelection';
import { Button } from '../util/buttons';
import CompanyClaimGroupEditFormFields from '@rd-web-markets/market/dist/claim_group/CompanyClaimGroupEditFormFields';
const CompanyClaimGroupEditForm = _ref => {
  let {
    claimGroup,
    setClaimGroup,
    admins,
    managers,
    changeContactClaimGroup,
    removeContactAttribute,
    claimGroupContacts,
    handleClaimGroupChange,
    handleRadioButtonChange,
    handleClaimTypeChange,
    defaultTemplate,
    claimTemplates,
    tasks,
    updateTasks,
    onUpdateConsultants,
    removeConsultantFromClaim,
    consultantsAndAdmins,
    isUnderReview,
    questionnaires,
    pageAccess,
    handleToaster
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [modalOpen, setModalOpen] = useState(false);
  const {
    t
  } = useTranslation();
  const taskTitle = t(TASK_TITLE);
  const showTasks = !['/de', '/be'].includes(process.env.PUBLIC_URL);
  const showManager = !['/be'].includes(process.env.PUBLIC_URL);
  // for IT market we don't show section CompanyClaimGroupEditFormFields, where is placed questionnaires select
  // but we need it, so we render it there if needed
  return /*#__PURE__*/React.createElement(React.Fragment, null, showTasks && tasks.length > 0 && /*#__PURE__*/React.createElement(ClaimTemplateTasksSelection, {
    show: modalOpen,
    initialTasks: tasks,
    index: 1,
    onHide: () => setModalOpen(false),
    onSubmit: updateTasks
  }), showTasks && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, taskTitle, "*"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    disabled: isUnderReview,
    as: "select",
    name: "claim_type_id",
    onChange: e => handleClaimTypeChange(e.target.value),
    size: "md",
    type: "text"
  }, /*#__PURE__*/React.createElement("option", {
    value: defaultTemplate?.id || null
  }, !!defaultTemplate ? SPRINT_CLAIM_NAME : ''), claimTemplates.map(ct => {
    return /*#__PURE__*/React.createElement("option", {
      key: ct.id,
      value: ct.id
    }, ct.name);
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !tasks || isUnderReview,
    size: "sm",
    variant: "info",
    onClick: () => setModalOpen(true)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "edit"), " ", t('customise')))))), CLAIM_GROUP_EDIT_PAGE_SHOW_YEAR_END_DROPDOWN && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "Claim Group Year End"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: "select",
    name: "year_end",
    onChange: handleClaimGroupChange,
    size: "md",
    value: claimGroup.year_end,
    disabled: isUnderReview
  }, /*#__PURE__*/React.createElement("option", {
    value: "31/12"
  }, "12/31"), /*#__PURE__*/React.createElement("option", {
    value: "31/03"
  }, "03/31")))))), showManager && /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: SelectManager,
    accountType: user.account_type,
    claimGroup: claimGroup,
    onChange: handleClaimGroupChange,
    admins: [...admins, ...managers],
    isUnderReview: isUnderReview
  }), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: SelectConsultants,
    removeConsultantFromClaim: removeConsultantFromClaim,
    claimGroup: claimGroup,
    consultantsAndAdmins: consultantsAndAdmins,
    onClaimGroupConsultantRolesChange: onUpdateConsultants,
    isUnderReview: isUnderReview,
    pageAccess: pageAccess || null
  }), SHOW_COMPANY_CLAIM_GROUP_EDIT_FORM_FIELDS && /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: CompanyClaimGroupEditFormFields,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    onClaimGroupFieldChange: handleClaimGroupChange,
    onRadioButtonChange: handleRadioButtonChange,
    claimGroupContacts: claimGroupContacts,
    changeContactClaimGroup: changeContactClaimGroup,
    removeContactAttribute: removeContactAttribute,
    isUnderReview: isUnderReview,
    questionnaires: questionnaires,
    handleToaster: handleToaster
  }));
};
export default CompanyClaimGroupEditForm;